module.exports = "label#securityLabel {\n  display: block; }\n\n.eye {\n  margin-top: .5em;\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/administracion/usuarios/usuarios-modal/usuarios-modal.component.scss
// module id = ./src/app/administracion/usuarios/usuarios-modal/usuarios-modal.component.scss
// module chunks = main